import { SearchFilterBuilder } from "../../../../../utilities/SearchFilterBuilder";
import { IGraphSearchUrlBuilder } from "../../../interfaces/IGraphSearchUrlBuilder";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { SearchValue } from "../../../redux/models/reduxModels";
import { BaseUrlSearchBuilder } from "./baseUrlSearchBuilder";

export class SharepointFolderSearchQueryStringBuilder extends BaseUrlSearchBuilder implements IGraphSearchUrlBuilder {
    constructor(private oneDriveWebUrl: string) {
        super()
    }
    buildFolderQuery = (currentDirectory: IPageSettings, searchValue: SearchValue) => {
        return this.builSearchUrl(currentDirectory, searchValue, false);
    }

    buildFileQuery = (currentDirectory: IPageSettings, searchValue: SearchValue) => {
        return this.builSearchUrl(currentDirectory, searchValue, true);
    }

    private builSearchUrl = (currentDirectory: IPageSettings, searchValue: SearchValue, isFile: boolean) => {
        return `(*${searchValue.value}*) site:\"${currentDirectory.webUrl !== undefined ? currentDirectory.webUrl + "/" + currentDirectory.directory : ""}\" ${this.setFileType(isFile)} ${searchValue?.filterType !== "" ? SearchFilterBuilder(searchValue.filterType, this.oneDriveWebUrl ) : ""}`;
    }
}